import { createListenerMiddleware, createSlice, isAnyOf, PayloadAction } from "@reduxjs/toolkit";
import { Database, databaseApiSlice } from "../../api/databaseApiSlice";
import { setSessionCookie, getSessionCookie } from "../../utils";

const sessionDatabase = getSessionCookie("DATABASE");
const sessionStudy = getSessionCookie("STUDY");

const initialState : {
    selectedStudy: string | null,
    selectedDatabase: string | null,
} = {
    selectedStudy: sessionStudy || null,
    selectedDatabase: sessionDatabase || null,
}

const databaseSlice = createSlice({
    name: 'database',
    initialState: initialState,
    reducers: {
        reset: () => initialState,
        setSelectedDatabase: (state, action: PayloadAction<Database>) => {
            const study = action.payload.name;
            const database = action.payload.database;

            setSessionCookie("DATABASE", database);
            setSessionCookie("STUDY", study);
            state.selectedStudy = study;
            state.selectedDatabase = database;
        }
    }
});

export const {
    reset,
    setSelectedDatabase
} = databaseSlice.actions;

export default databaseSlice.reducer;

export const selectSelectedDatabase = (state: any) => state.database.selectedDatabase;
export const selectSelectedStudy = (state: any) => state.database.selectedStudy;

const databaseListenerMiddleware = createListenerMiddleware();

databaseListenerMiddleware.startListening({
    matcher: isAnyOf(databaseApiSlice.endpoints.getDatabaseLocations.matchFulfilled),
    effect: async (action, listenerApi) => {
        const selectedDatabase = selectSelectedDatabase(listenerApi.getState());
        const availableDatabases: any = action.payload;
        let database = availableDatabases?.find(
            (database: Database) => database.database === selectedDatabase
        );
        if (!database) {
            console.error(`No study matching ${selectedDatabase} found. Setting the default.`);
            database = availableDatabases?.find(
                (database: Database) => database.isDefault
            );
        }

        if (!database) {
            console.error(`No default study found. Setting the first in the database list.`);
            listenerApi.dispatch(setSelectedDatabase(availableDatabases[0]));
        } else {
            listenerApi.dispatch(setSelectedDatabase(database));
        }
    }
});

export { databaseListenerMiddleware };